import actionTypes from './actionTypes';

export const updateExport = (payload) => ({
    type: actionTypes.UDPATE_EXPORT,
    payload,
});
export const incrementExportNumber = () => ({
    type: actionTypes.INCREMENT_EXPORT_NUMBER,
});
